import type { Creator } from '@/types';
import { categoryLabel } from './creator-formatters';
import { rankToFollowerRange } from '@/utils/formatters';

const HEADERS = [
  'Username',
  'Display Name',
  'Followers',
  'Email',
  'Type',
  'Category',
  'Follower Range',
  'Sex',
  'Status',
  'Bio',
  'Notes',
  'Post URL',
  'Created',
];

function escapeCSV(value: string): string {
  if (/[",\n]/.test(value)) return `"${value.replace(/"/g, '""')}"`;
  return value;
}

function creatorToRow(creator: Creator): string {
  const cells = [
    creator.ig_username,
    creator.display_name,
    String(creator.followers),
    creator.email,
    creator.creator_type,
    categoryLabel(creator.creator_type, creator.category),
    rankToFollowerRange(creator.rank),
    creator.sex,
    creator.status,
    creator.bio,
    creator.notes,
    creator.post_url,
    creator.created,
  ];
  return cells.map(escapeCSV).join(',');
}

export function convertCreatorsToCSV(creators: Creator[]): string {
  return [HEADERS.join(','), ...creators.map(creatorToRow)].join('\n');
}

export function downloadCSV(content: string, filename: string): void {
  const blob = new globalThis.Blob([content], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
